import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SessionService } from '@core/services/session.service';
import { UserApiService } from '@core/services/user-api.service';
import { SideBarItemInput } from '@models/ISidebar';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-operaciones-destacadas',
  imports: [NgOptimizedImage, RouterModule, TranslateModule],
  templateUrl: './operaciones-destacadas.component.html',
  styleUrl: './operaciones-destacadas.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperacionesDestacadasComponent implements OnInit {
  operaciones = signal<SideBarItemInput[]>([]);

  constructor(
    private sessionService: SessionService,
    private userApiService: UserApiService
  ) { }

  ngOnInit(): void {
    const user = this.sessionService.getUserInfo();
    if (!user) {
      return;
    }
    this.getOperacionesDestacadasPerfil(user.perfil, user.notificarTraspasos, user.citaPrevia, user.cuadreEntregasNumeroPedido);
  }


  getOperacionesDestacadasPerfil(perfil: string, notificarTraspaso: boolean, citaPrevia: boolean, cuadreEntregasNumeroPedido: boolean) {
    this.userApiService.getOperacionesDestacadasPerfil(perfil, notificarTraspaso, citaPrevia, cuadreEntregasNumeroPedido).subscribe((r) => {
      // this.logger.info(r);
      r.forEach((item) => {
        item.icono = this.parseIconName(item.icono!);
        item.traduccion = item.nombre.replace(/\s+/g, "").toUpperCase();
      });
      this.operaciones.set(r);
    });
  }

  formatearNombre(nombre: SideBarItemInput) {

    if (nombre.accion.includes('NotificarReclamacion')) {
      return 'Reclamaciones';
    }

    if (nombre.accion.includes('NotificarTraspaso')) {
      return 'Traspasos';
    }

    return nombre.nombre;
  }

  parseIconName(icon: string | undefined) {
    if (icon?.includes('ico-previsiones.png')) {
      return '/icons/fondo-blanco/Previsión semanal fondo blanco.webp';
    }
    if (icon?.includes('ico-pedidos.png')) {
      return '/icons/fondo-blanco/Caja 2 Fondo Blanco.webp';
    }
    if (icon?.includes('ico-traspasos.png')) {
      return '/icons/fondo-blanco/svg/Traspasos fondo blanco-53.svg';
    }
    if (icon?.includes('ico-reclamaciones.png')) {
      return '/icons/fondo-blanco/svg/Reclamaciones fondo blanco.svg';
    }
    if (icon?.includes('ico-cuadrepedidos.png')) {
      return '/icons/fondo-blanco/Caja movimiento Fondo Blanco.webp';
    }
    return icon;
  }
}
